import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MessageListItem from './ListItems/MessageListItem';
import CBSelect from '../../shared/CBSelect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, getUrlId } from '../../../utils/utils';
import AddMessageButton from './ListItems/AddMessageButton';
import { searchMessages as _searchMessages } from '../../../actions/searchActions';

class VehicleDetailsMessageList extends React.Component {
  componentWillMount() {
    const { searchMessages, searchRequest, vehicle } = this.props;
    searchMessages({
      vehicle_id: vehicle.id,
      search: searchRequest.messageFilters.search,
      message_type: searchRequest.messageFilters.messageType,
    });
  }

  getFilteredMessages = messages => {
    const { searchRequest } = this.props;
    const { messageIDs } = searchRequest;

    if (!messageIDs) {
      return messages;
    }

    return messages.filter(message =>
      messageIDs.includes(parseInt(message.id)),
    );
  };

  isSelected = (message, idx) => {
    const { match } = this.props;
    const urlParts = window.location.pathname.split('/');
    const index = urlParts.indexOf('messages') + 1;

    if (index && urlParts[index]) {
      return message.id == urlParts[index];
    }

    return idx == 0;
  };

  messageSelected = e => {
    const { history, vehicle } = this.props;
    history.push(`/vehicle/${vehicle.id}/messages/${e.target.value}`);
  };

  //Do not remove. For unknown reasons the view won't re-render without this.
  static getDerivedStateFromProps(nextProps, prevState) {}

  render() {
    const { vehicle, location, history } = this.props;
    const { messages } = vehicle;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div
            style={getStyle(
              screenSize,
              styles,
              screenSize !== 'small' ? 'listContainer' : 'container',
            )}
          >
            {screenSize !== 'small' && (
              <div>
                <AddMessageButton vehicle={vehicle} />
                {this.getFilteredMessages(messages).map((message, idx) => (
                  <MessageListItem
                    key={message.id}
                    vehicle={vehicle}
                    message={message}
                    history={history}
                    isSelected={this.isSelected(message, idx)}
                  />
                ))}
              </div>
            )}
            {screenSize === 'small' && (
              <Fragment>
                <div>
                  <AddMessageButton vehicle={vehicle} />
                </div>
                <div style={getStyle(screenSize, styles, 'selectContainer')}>
                  <CBSelect
                    value={getUrlId(location.pathname)}
                    onChange={this.messageSelected}
                    >
                    {this.getFilteredMessages(messages).map(message => (
                      <option key={message.id} value={message.id}>
                        {`${moment(message.created_at).format('D.M.Y')} | ${
                          message.subject
                        }`}
                      </option>
                    ))}
                  </CBSelect>
                </div>
              </Fragment>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '25%',
    },
    selectContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 40,
      marginRight: 15,
      marginLeft: 15,
      marginTop: 40,
    },
  },
  small: {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'rgba(0, 149, 218, 0.4)',
      width: '100%',
      maxHeight: 300,
      overflow: 'auto',
    },
  },
};

function mapStateToProps(state) {
  return {
    searchRequest: state.search,
  };
}

export default connect(
  mapStateToProps,
  {
    searchMessages: _searchMessages,
  },
)(withRouter(VehicleDetailsMessageList));
